import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import ErrorDisplay from "../error-display";
import HttpRequest from "../../../services/HttpRequest";

interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

class ErrorBoundary extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      this.state.hasError &&
      !prevState.hasError &&
      this.state.error &&
      this.state.errorInfo
    ) {
      const { pathname, search, hash } = this.props.location;

      const errorPath = `${pathname}${search}${hash}`;
      const errorDescription = [
        `Name: ${this.state.error.name}`,
        `Message: ${this.state.error.message}`,
        `Stack: ${this.state.error.stack || "No stack trace available"}`,
        `Component Stack: ${this.state.errorInfo.componentStack}`,
        `User Agent: ${navigator.userAgent}`,
        `Timestamp: ${new Date().toISOString()}`,
      ];

      HttpRequest.request({
        url: "/error/log",
        method: "POST",
        data: {
          errorPath,
          errorDescription,
        },
      }).catch((err) => {
        console.error("Error log sending failed:", err);
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorDisplay />;
    }
    return this.props.children || null;
  }

}

export default withRouter(ErrorBoundary);
